/*
 * Polyfills
 */
import './polyfills/object-fit';

/*
 * Modules
 */
import './modules/set-navigation-dropdown-class';
import './modules/handle-form-modal';
import './modules/handle-navigation-mobile-dropdown';
import './modules/template-animation';
import './modules/video-animation';
import './modules/video-animation-play-video';
import './modules/scroll-to';
import './modules/handleAccordions';
import './modules/handleAccordionsSidebar';
import './modules/handle-form-modal';
import './modules/scrollspy-navigation';
import './modules/handle-sticky-sidebar';
import './modules/hero-animation';
import './modules/video-animation-borders';
import './modules/templates-animation';
import './modules/positioning-hero-on-mobile';
import './modules/handle-words-typing';
import './modules/toggle-mobile-navigation';
import './modules/handle-slider';
import './modules/handle-scroll-to-section';
